export default {
    BLACKOUT:'companies/:company_id/communication/blackout'
}
